(() => {
  if (customElements.get('fr-home-rail')) return;
  customElements.define('fr-home-rail', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const track = this.querySelector('[data-home-rail-track]');
      const controls = this.querySelector('[data-home-rail-buttons]');
      const previous = this.querySelector('[data-home-rail-prev]');
      const next = this.querySelector('[data-home-rail-next]');
      if (!track || !controls || !previous || !next) return;
      const rtl = getComputedStyle(track).direction === 'rtl';
      const update = () => {
        const max = track.scrollWidth - track.clientWidth;
        const position = Math.abs(track.scrollLeft);
        controls.hidden = max < 2;
        previous.disabled = position < 2;
        next.disabled = position >= max - 2;
      };
      const move = direction => {
        const card = track.firstElementChild;
        const style = getComputedStyle(track);
        const distance = card ? card.getBoundingClientRect().width + (parseFloat(style.columnGap) || 0) : track.clientWidth;
        track.scrollBy({ left: direction * distance * (rtl ? -1 : 1), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      };
      previous.addEventListener('click', () => move(-1), { signal });
      next.addEventListener('click', () => move(1), { signal });
      track.addEventListener('scroll', update, { passive: true, signal });
      this.observer = new ResizeObserver(update);
      this.observer.observe(track);
      update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
    }
  });
})();
